// import React, { useEffect, useState } from "react";
// import { Button, Table, Row, Col, Card } from "react-bootstrap";
// import { BsFiletypeXls, BsEye, BsPerson } from "react-icons/bs";
// import Swal from "sweetalert2";
// import { HiOutlineChevronLeft } from "react-icons/hi";
// import { HiChevronRight } from "react-icons/hi2";
// import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;

// function Unit_sqyd_added() {
//   const [projects, setProjects] = useState([]);
//   const [plots, setPlots] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [ledgerData, setLedgerData] = useState(null);
//   const [formData, setFormData] = useState({
//     project_id: "",
//     plot_id: "",
//     start_date: "",
//     end_date: "",
//   });
//   const [filteredPlots, setFilteredPlots] = useState([]);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");

//   // Filter toggle state
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   // Helper function to format date only (DD-MM-YYYY)
//   const formatDateOnly = (dateStr) => {
//     if (!dateStr) return "-";

//     if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
//       return dateStr;
//     }

//     const date = new Date(dateStr);
//     if (isNaN(date.getTime())) return "-";

//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };

//   useEffect(() => {
//     const fetchProjects = async () => {
//       const token = getAuthToken();
//       if (!token) return;

//       try {
//         const projectsResponse = await fetch(`${API_URL}/project-list-block`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         const projectsData = await projectsResponse.json();

//         if (projectsData && Array.isArray(projectsData)) {
//           setProjects(projectsData);
//         } else if (projectsData?.data && Array.isArray(projectsData.data)) {
//           setProjects(projectsData.data);
//         } else if (projectsData?.status && projectsData?.data) {
//           setProjects(projectsData.data);
//         } else {
//           setProjects([]);
//         }
//         setError(null);
//       } catch (err) {
//         console.error("Error fetching projects:", err);
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: "Failed to load projects. Please try again.",
//           confirmButtonText: "OK",
//           confirmButtonColor: "#3085d6",
//         });
//       }
//     };

//     fetchProjects();
//   }, []);

//   useEffect(() => {
//     const fetchPlots = async () => {
//       if (!formData.project_id) {
//         setFilteredPlots([]);
//         setPlots([]);
//         return;
//       }
//       const token = getAuthToken();
//       if (!token) return;

//       setLoading(true);
//       try {
//         const plotsResponse = await fetch(
//           `${API_URL}/all-plot-list-by-id?project_id=${formData.project_id}`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const plotsData = await plotsResponse.json();
//         if (plotsData.status) {
//           const allPlots = plotsData.data || [];
//           setPlots(allPlots);
//           setFilteredPlots(allPlots);
//         } else {
//           setPlots([]);
//           setFilteredPlots([]);
//         }
//       } catch (err) {
//         console.error("Error fetching plots:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPlots();
//   }, [formData.project_id]);

//   const handleProjectChange = (e) => {
//     const projectId = e.target.value;
//     setFormData((prev) => ({
//       ...prev,
//       project_id: projectId,
//       plot_id: "",
//     }));
//     setLedgerData(null);
//     setError(null);
//   };

//   const handlePlotChange = (e) => {
//     const plotId = e.target.value;
//     setFormData((prev) => ({
//       ...prev,
//       plot_id: plotId,
//     }));
//   };

//   const fetchLedgerData = async (page = 1) => {
//     if (!formData.project_id || !formData.plot_id) {
//       Swal.fire("Warning", "Please select both project and unit", "warning");
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     const token = getAuthToken();

//     try {
//       const params = new URLSearchParams({
//         project_id: formData.project_id,
//         plot_id: formData.plot_id,
//       });

//       const url = `${API_URL}/plot-area-ledger-report?${params.toString()}`;
//       console.log("Fetching URL:", url);

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch ledger data.");
//       }

//       const data = await response.json();
//       console.log("API Response:", data);

//       if (data.status === "1") {
//         let transformedData = null;

//         if (data.plots && data.plots.length > 0) {
//           const plotData = data.plots[0];
//           transformedData = {
//             user: data.user || {},
//             project: plotData.project || {},
//             plot: plotData.plot || {},
//             direct_entries: plotData.plot_entries || [],
//             commission_entries: plotData.commissions || [],
//             all_entries: [
//               ...(plotData.plot_entries || []),
//               ...(plotData.commissions || []),
//             ],
//           };
//         } else if (data.data) {
//           transformedData = data.data;
//         }

//         if (transformedData) {
//           setLedgerData(transformedData);

//           const totalEntries = transformedData.all_entries?.length || 0;
//           setTotalPages(Math.ceil(totalEntries / 10) || 1);
//           setCurrentPage(page);
//         } else {
//           setLedgerData(null);
//           Swal.fire("Info", "No data found for this plot", "info");
//         }
//       } else if (
//         data.status === "1" &&
//         data.message === "No entries found for this user on this plot"
//       ) {
//         setLedgerData({
//           user: data.data?.user || {},
//           project: data.data?.project || {},
//           plot: data.data?.plot || {},
//           direct_entries: [],
//           commission_entries: [],
//           all_entries: [],
//         });
//         setTotalPages(1);
//         setCurrentPage(1);
//         Swal.fire("Info", "No entries found for this user on this plot", "info");
//       } else {
//         console.log("Unexpected response structure:", data);
//         setLedgerData(null);
//         Swal.fire("Info", data.message || "No data found", "info");
//       }
//     } catch (err) {
//       console.error("Fetch ledger data error:", err);
//       setLedgerData(null);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to fetch ledger data. Please try again.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getFlatTableData = () => {
//     if (!ledgerData) {
//       return [];
//     }

//     const flatData = [];

//     const project = ledgerData.project || {};
//     const plot = ledgerData.plot || {};

//     if (ledgerData.direct_entries && Array.isArray(ledgerData.direct_entries)) {
//       ledgerData.direct_entries.forEach((entry) => {
//         const newSqyd = parseFloat(entry.new_sqyd || 0);
//         const oldSqyd = parseFloat(entry.old_sqyd || 0);
//         const areaDistributed = (newSqyd - oldSqyd).toFixed(2);

//         const dateTime = entry.status_date || "-";

//         flatData.push({
//           projectName: project.name || "-",
//           unitNo: plot.plot_shop_villa_no || "-",
//           name: entry.customer_name || "Customer",
//           mobile: entry.customer_mobile || "-",
//           oldSqyd: entry.old_sqyd || "0.00",
//           newSqyd: areaDistributed,
//           totalSqyd: entry.new_sqyd || "0.00",
//           role:
//             entry.level === "1"
//               ? "Direct Customer"
//               : `Level ${entry.level} Customer`,
//           date: formatDateOnly(dateTime),
//           approveDate: formatDateOnly(dateTime),
//           type: "direct",
//           level: entry.level,
//           rate: entry.rate,
//           grossPayout: entry.gross_payout,
//           netPayout: entry.net_payout,
//           created_at: entry.created_at || "",
//           updated_at: entry.updated_at || "",
//           lead_property_date: entry.status_date || "",
//           lead_property_status_date: entry.status_date || "",
//         });
//       });
//     }

//     if (
//       ledgerData.commission_entries &&
//       Array.isArray(ledgerData.commission_entries)
//     ) {
//       ledgerData.commission_entries.forEach((commission) => {
//         const newSqyd = parseFloat(commission.new_sqyd || 0);
//         const oldSqyd = parseFloat(commission.old_sqyd || 0);
//         const areaDistributed = (newSqyd - oldSqyd).toFixed(2);

//         let role = `Level ${commission.level} Commission`;
//         if (commission.user_id === ledgerData.user?.id) {
//           role = `Level ${commission.level} Commission (Received)`;
//         } else if (commission.parent_id === ledgerData.user?.id) {
//           role = `Level ${commission.level} Commission (Given)`;
//         }

//         const dateTime = commission.status_date || "-";

//         flatData.push({
//           projectName: project.name || "-",
//           unitNo: plot.plot_shop_villa_no || "-",
//           name:
//             commission.customer_name ||
//             `Level ${commission.level} Associate`,
//           mobile: commission.customer_mobile || "-",
//           oldSqyd: commission.old_sqyd || "0.00",
//           newSqyd: areaDistributed,
//           totalSqyd: commission.new_sqyd || "0.00",
//           role: role,
//           date: formatDateOnly(dateTime),
//           approveDate: formatDateOnly(dateTime),
//           type: "commission",
//           level: commission.level,
//           commissionAmount:
//             commission.commission_amount || commission.gross_payout,
//           grossPayout: commission.gross_payout,
//           netPayout: commission.net_payout,
//           created_at: commission.created_at || "",
//           updated_at: commission.updated_at || "",
//           lead_property_date: commission.status_date || "",
//           lead_property_status_date: commission.status_date || "",
//         });
//       });
//     }

//     flatData.sort((a, b) => {
//       if (a.approveDate === "-") return 1;
//       if (b.approveDate === "-") return -1;
//       return new Date(a.approveDate) - new Date(b.approveDate);
//     });

//     console.log("Flat data for table:", flatData);
//     return flatData;
//   };

//   const getCurrentPageData = () => {
//     const flatData = getFlatTableData();
//     const startIndex = (currentPage - 1) * 10;
//     const endIndex = startIndex + 10;
//     return flatData.slice(startIndex, endIndex);
//   };

//   const getFilteredData = () => {
//     const flatData = getFlatTableData();

//     if (!searchQuery) {
//       const startIndex = (currentPage - 1) * 10;
//       const endIndex = startIndex + 10;
//       return flatData.slice(startIndex, endIndex);
//     }

//     const filtered = flatData.filter(
//       (entry) =>
//         entry.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         entry.mobile?.includes(searchQuery) ||
//         entry.role?.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     const newTotalPages = Math.ceil(filtered.length / 10);
//     if (newTotalPages !== totalPages) {
//       setTotalPages(newTotalPages || 1);
//     }

//     const startIndex = (currentPage - 1) * 10;
//     const endIndex = startIndex + 10;
//     return filtered.slice(startIndex, endIndex);
//   };

//   useEffect(() => {
//     if (ledgerData) {
//       const flatData = getFlatTableData();
//       setTotalPages(Math.ceil(flatData.length / 10) || 1);
//     }
//   }, [ledgerData]);

//   const handleClearFilters = () => {
//     setFormData({
//       project_id: "",
//       plot_id: "",
//       start_date: "",
//       end_date: "",
//     });
//     setLedgerData(null);
//     setFilteredPlots([]);
//     setSearchQuery("");
//     setCurrentPage(1);
//     setError(null);
//   };

//   const handleExportExcel = () => {
//     const flatData = getFlatTableData();
//     if (!flatData.length) return;

//     const headers = [
//       "SR. No.",
//       "Date",
//       "Project",
//       "Unit",
//       "Associate Name",
//       "Associate Mobile",
//       "Old SQYD",
//       "New SQYD",
//       "Total SQYD",
//       "Level",
//     ];

//     const rows = flatData.map((entry, index) => [
//       index + 1,
//       entry.date,
//       entry.projectName,
//       entry.unitNo,
//       entry.name,
//       entry.mobile,
//       entry.oldSqyd,
//       entry.newSqyd,
//       entry.totalSqyd,
//       entry.level || "-",
//     ]);

//     const csvContent = [
//       headers.join(","),
//       ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
//     ].join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv" });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");

//     const date = new Date().toISOString().split("T")[0];
//     a.download = `unit_sqyd_report_${date}.csv`;

//     a.href = url;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber > 0 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   if (loading && projects.length === 0) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{ minHeight: "80vh" }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="padding_15">
//       <div className="userlist">
//         <div className="card bg-white">
//           <div className="card-header">
//             <div className="d-flex align-items-md-center flex-wrap-mobile justify-content-between">
//               <div className="titlepage">
//                 <h3 style={{ whiteSpace: "normal" }}>
//                   Unit SQYD Added To All Associates In One Unit Lists
//                 </h3>
//               </div>

//               <div className="d-flex gap-2 align-items-center">
//                 {getFlatTableData().length > 0 && (
//                   <Button
//                     variant="success"
//                     onClick={handleExportExcel}
//                     title="Export to Excel"
//                   >
//                     <BsFiletypeXls /> Export
//                   </Button>
//                 )}

//                 <button
//                   className={`filter-toggle-btn btn btn-primary ${
//                     isFilterActive ? "active" : ""
//                   }`}
//                   onClick={handleToggle}
//                   title={isFilterActive ? "Hide Filters" : "Show Filters"}
//                 >
//                   {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="card-body">
//             {/* ═══════════ FILTER SECTION ═══════════ */}
//             {isFilterActive && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "flex-start",
//                   gap: "12px",
//                   flexWrap: "wrap",
//                   marginBottom: "20px",
//                   marginTop: "10px",
//                 }}
//               >
//                 {/* Project */}
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     flex: "1 1 180px",
//                     minWidth: 0,
//                   }}
//                 >
//                   <label
//                     style={{
//                       display: "block",
//                       minHeight: "22px",
//                       marginBottom: "6px",
//                       fontSize: "14px",
//                       fontWeight: 500,
//                       color: "#0f172a",
//                       lineHeight: 1.2,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     Project <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className="form-control"
//                     value={formData.project_id}
//                     onChange={handleProjectChange}
//                     style={{
//                       height: "44px",
//                       padding: "0 14px",
//                       fontSize: "14px",
//                       border: "1.5px solid #e2e8f0",
//                       borderRadius: "8px",
//                       background: "#fff",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     <option value="">Select Project</option>
//                     {projects.map((project) => (
//                       <option key={project.id} value={project.id}>
//                         {project.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Unit */}
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     flex: "1 1 180px",
//                     minWidth: 0,
//                   }}
//                 >
//                   <label
//                     style={{
//                       display: "block",
//                       minHeight: "22px",
//                       marginBottom: "6px",
//                       fontSize: "14px",
//                       fontWeight: 500,
//                       color: "#0f172a",
//                       lineHeight: 1.2,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     Unit <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className="form-control"
//                     value={formData.plot_id}
//                     onChange={handlePlotChange}
//                     disabled={!formData.project_id}
//                     style={{
//                       height: "44px",
//                       padding: "0 14px",
//                       fontSize: "14px",
//                       border: "1.5px solid #e2e8f0",
//                       borderRadius: "8px",
//                       background: "#fff",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     <option value="">Select Unit</option>
//                     {filteredPlots.map((plot) => (
//                       <option key={plot.id} value={plot.id}>
//                         {plot.plot_shop_villa_no} - {plot.colony_name}
//                         {plot.total_area ? ` (${plot.total_area} sq.yd)` : ""}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Search */}
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     flex: "1.4 1 220px",
//                     minWidth: 0,
//                   }}
//                 >
//                   <label
//                     style={{
//                       display: "block",
//                       minHeight: "22px",
//                       marginBottom: "6px",
//                       fontSize: "14px",
//                       fontWeight: 500,
//                       color: "#0f172a",
//                       lineHeight: 1.2,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     Search Associate
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control py-2"
//                     placeholder="Search by name, mobile or role..."
//                     value={searchQuery}
//                     onChange={handleSearchChange}
//                     style={{
//                       height: "44px",
//                       padding: "0 14px",
//                       fontSize: "14px",
//                       border: "1.5px solid #e2e8f0",
//                       borderRadius: "8px",
//                       background: "#fff",
//                       boxSizing: "border-box",
//                     }}
//                   />
//                 </div>

//                 {/* Buttons — inline aligned with inputs */}
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "8px",
//                     alignItems: "center",
//                     paddingTop: "28px",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Button
//                     variant="primary"
//                     onClick={() => {
//                       setCurrentPage(1);
//                       fetchLedgerData();
//                     }}
//                     disabled={
//                       !formData.project_id || !formData.plot_id || loading
//                     }
//                     style={{
//                       height: "44px",
//                       padding: "0 22px",
//                       fontSize: "13.5px",
//                       fontWeight: 600,
//                       borderRadius: "8px",
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       whiteSpace: "nowrap",
//                       background:
//                         "linear-gradient(135deg, #1e1b4b 0%, #4c1d95 100%)",
//                       border: "none",
//                       boxShadow: "0 4px 12px rgba(76, 29, 149, 0.35)",
//                       color: "#fff",
//                     }}
//                   >
//                     {loading ? "Loading..." : "View Details"}
//                   </Button>

//                   <Button
//                     variant="outline-light"
//                     onClick={handleClearFilters}
//                     style={{
//                       height: "44px",
//                       padding: "0 22px",
//                       fontSize: "13.5px",
//                       fontWeight: 600,
//                       borderRadius: "8px",
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       whiteSpace: "nowrap",
//                       background: "#ffffff",
//                       border: "1.5px solid #e2e8f0",
//                       color: "#475569",
//                     }}
//                   >
//                     Clear
//                   </Button>
//                 </div>
//               </div>
//             )}

//             {error && (
//               <div className="alert alert-danger mb-3" role="alert">
//                 {error}
//               </div>
//             )}

//             <div className="mb-4"></div>

//             {loading ? (
//               <div className="text-center py-5">
//                 <div className="spinner-border text-primary" role="status">
//                   <span className="visually-hidden">Loading...</span>
//                 </div>
//                 <p className="mt-3">Loading ledger data...</p>
//               </div>
//             ) : ledgerData ? (
//               <>
//                 {/* Main User Card */}
//                 {ledgerData.user && (
//                   <Card className="mb-4 border-primary">
//                     <Card.Header className="bg-primary text-white">
//                       <h5 className="mb-0">
//                         <BsPerson className="me-2" />
//                         Main User Details
//                       </h5>
//                     </Card.Header>
//                     <Card.Body>
//                       <Row>
//                         <Col md={3}>
//                           <strong>Name:</strong>
//                           <p className="mb-0">
//                             {ledgerData.user.name || "-"}
//                           </p>
//                         </Col>
//                         <Col md={3}>
//                           <strong>Mobile:</strong>
//                           <p className="mb-0">
//                             {ledgerData.user.mobile || "-"}
//                           </p>
//                         </Col>
//                         <Col md={3}>
//                           <strong>Total Area (SQYD):</strong>
//                           <p className="mb-0">
//                             {parseFloat(
//                               ledgerData.user.buysqrt || 0
//                             ).toFixed(2)}
//                           </p>
//                         </Col>
//                         <Col md={3}>
//                           <strong>Email:</strong>
//                           <p className="mb-0">
//                             {ledgerData.user.email || "-"}
//                           </p>
//                         </Col>
//                       </Row>
//                     </Card.Body>
//                   </Card>
//                 )}

//                 <div className="table-responsive">
//                   <Table striped bordered hover className="mb-0">
//                     <thead className="table-dark">
//                       <tr>
//                         <th>SR. No.</th>
//                         <th>Date</th>
//                         <th>Project</th>
//                         <th>Unit</th>
//                         <th>Customer Name</th>
//                         <th>Customer Mobile</th>
//                         <th>Old SQYD</th>
//                         <th>New SQYD</th>
//                         <th>Total SQYD</th>
//                         <th>Level</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {getFilteredData().length > 0 ? (
//                         getFilteredData().map((entry, index) => {
//                           const actualIndex =
//                             (currentPage - 1) * 10 + index + 1;

//                           return (
//                             <tr
//                               key={`${entry.type}-${index}-${entry.mobile}`}
//                             >
//                               <td>{actualIndex}</td>
//                               <td>{entry.date}</td>
//                               <td>{entry.projectName}</td>
//                               <td>{entry.unitNo?.toUpperCase()}</td>
//                               <td>{entry.name}</td>
//                               <td>{entry.mobile}</td>
//                               <td>
//                                 {parseFloat(entry.oldSqyd).toFixed(2)}
//                               </td>
//                               <td>
//                                 {parseFloat(entry.newSqyd).toFixed(2)}
//                               </td>
//                               <td>
//                                 {parseFloat(entry.totalSqyd).toFixed(2)}
//                               </td>
//                               <td>{entry.level || "-"}</td>
//                             </tr>
//                           );
//                         })
//                       ) : (
//                         <tr>
//                           <td
//                             colSpan="10"
//                             className="text-center text-muted"
//                           >
//                             No matching records found
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </Table>
//                 </div>

//                 {totalPages > 1 && (
//                   <div className="d-flex justify-content-end mt-3">
//                     <nav>
//                       <ul className="pagination">
//                         <li
//                           className={`page-item ${
//                             currentPage === 1 ? "disabled" : ""
//                           }`}
//                         >
//                           <button
//                             className="page-link"
//                             onClick={() =>
//                               handlePageChange(currentPage - 1)
//                             }
//                             disabled={currentPage === 1}
//                           >
//                             <HiOutlineChevronLeft />
//                           </button>
//                         </li>

//                         {(() => {
//                           const pages = [];
//                           const maxVisiblePages = 5;

//                           if (totalPages <= maxVisiblePages + 2) {
//                             for (let i = 1; i <= totalPages; i++) {
//                               pages.push(
//                                 <li
//                                   key={i}
//                                   className={`page-item ${
//                                     i === currentPage ? "active" : ""
//                                   }`}
//                                 >
//                                   <button
//                                     className="page-link"
//                                     onClick={() => handlePageChange(i)}
//                                   >
//                                     {i}
//                                   </button>
//                                 </li>
//                               );
//                             }
//                           } else {
//                             pages.push(
//                               <li
//                                 key={1}
//                                 className={`page-item ${
//                                   1 === currentPage ? "active" : ""
//                                 }`}
//                               >
//                                 <button
//                                   className="page-link"
//                                   onClick={() => handlePageChange(1)}
//                                 >
//                                   1
//                                 </button>
//                               </li>
//                             );

//                             if (currentPage > 3) {
//                               pages.push(
//                                 <li
//                                   key="ellipsis1"
//                                   className="page-item disabled"
//                                 >
//                                   <span className="page-link">...</span>
//                                 </li>
//                               );
//                             }

//                             const start = Math.max(2, currentPage - 1);
//                             const end = Math.min(
//                               totalPages - 1,
//                               currentPage + 1
//                             );

//                             for (let i = start; i <= end; i++) {
//                               if (i > 1 && i < totalPages) {
//                                 pages.push(
//                                   <li
//                                     key={i}
//                                     className={`page-item ${
//                                       i === currentPage ? "active" : ""
//                                     }`}
//                                   >
//                                     <button
//                                       className="page-link"
//                                       onClick={() => handlePageChange(i)}
//                                     >
//                                       {i}
//                                     </button>
//                                   </li>
//                                 );
//                               }
//                             }

//                             if (currentPage < totalPages - 2) {
//                               pages.push(
//                                 <li
//                                   key="ellipsis2"
//                                   className="page-item disabled"
//                                 >
//                                   <span className="page-link">...</span>
//                                 </li>
//                               );
//                             }

//                             if (totalPages > 1) {
//                               pages.push(
//                                 <li
//                                   key={totalPages}
//                                   className={`page-item ${
//                                     totalPages === currentPage
//                                       ? "active"
//                                       : ""
//                                   }`}
//                                 >
//                                   <button
//                                     className="page-link"
//                                     onClick={() =>
//                                       handlePageChange(totalPages)
//                                     }
//                                   >
//                                     {totalPages}
//                                   </button>
//                                 </li>
//                               );
//                             }
//                           }

//                           return pages;
//                         })()}

//                         <li
//                           className={`page-item ${
//                             currentPage === totalPages ? "disabled" : ""
//                           }`}
//                         >
//                           <button
//                             className="page-link"
//                             onClick={() =>
//                               handlePageChange(currentPage + 1)
//                             }
//                             disabled={currentPage === totalPages}
//                           >
//                             <HiChevronRight />
//                           </button>
//                         </li>
//                       </ul>
//                     </nav>
//                   </div>
//                 )}
//               </>
//             ) : (
//               <div className="text-center">
//                 <BsEye size={32} className="text-muted" />
//                 <h6 className="text-muted">No Data Available</h6>
//                 <p className="text-muted">
//                   Please select a project and unit to view the Unit SQYD Added
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Unit_sqyd_added;

import React, { useEffect, useState } from "react";
import { Button, Table, Row, Col, Card } from "react-bootstrap";
import { BsFiletypeXls, BsEye, BsPerson } from "react-icons/bs";
import Swal from "sweetalert2";
import { HiOutlineChevronLeft } from "react-icons/hi";
import { HiChevronRight } from "react-icons/hi2";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;

function Unit_sqyd_added() {
  const [projects, setProjects] = useState([]);
  const [plots, setPlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ledgerData, setLedgerData] = useState(null);
  const [formData, setFormData] = useState({
    project_id: "",
    plot_id: "",
    start_date: "",
    end_date: "",
  });
  const [filteredPlots, setFilteredPlots] = useState([]);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  // Filter toggle state
  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleToggle = () => {
    setIsFilterActive(!isFilterActive);
  };

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  // Helper function to format date only (DD-MM-YYYY)
  const formatDateOnly = (dateStr) => {
    if (!dateStr) return "-";

    if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
      return dateStr;
    }

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "-";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchProjects = async () => {
      const token = getAuthToken();
      if (!token) return;

      try {
        const projectsResponse = await fetch(`${API_URL}/project-list-block`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const projectsData = await projectsResponse.json();

        if (projectsData && Array.isArray(projectsData)) {
          setProjects(projectsData);
        } else if (projectsData?.data && Array.isArray(projectsData.data)) {
          setProjects(projectsData.data);
        } else if (projectsData?.status && projectsData?.data) {
          setProjects(projectsData.data);
        } else {
          setProjects([]);
        }
        setError(null);
      } catch (err) {
        console.error("Error fetching projects:", err);
        // ❌ Alert hata diya
        setError("Failed to load projects. Please try again.");
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    const fetchPlots = async () => {
      if (!formData.project_id) {
        setFilteredPlots([]);
        setPlots([]);
        return;
      }
      const token = getAuthToken();
      if (!token) return;

      setLoading(true);
      try {
        const plotsResponse = await fetch(
          `${API_URL}/all-plot-list-by-id?project_id=${formData.project_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const plotsData = await plotsResponse.json();
        if (plotsData.status) {
          const allPlots = plotsData.data || [];
          setPlots(allPlots);
          setFilteredPlots(allPlots);
        } else {
          setPlots([]);
          setFilteredPlots([]);
        }
      } catch (err) {
        console.error("Error fetching plots:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlots();
  }, [formData.project_id]);

  const handleProjectChange = (e) => {
    const projectId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      project_id: projectId,
      plot_id: "",
    }));
    setLedgerData(null);
    setError(null);
  };

  const handlePlotChange = (e) => {
    const plotId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      plot_id: plotId,
    }));
  };

  const fetchLedgerData = async (page = 1) => {
    if (!formData.project_id || !formData.plot_id) {
      setError("Please select both project and unit");
      return;
    }

    setLoading(true);
    setError(null);
    const token = getAuthToken();

    try {
      const params = new URLSearchParams({
        project_id: formData.project_id,
        plot_id: formData.plot_id,
      });

      const url = `${API_URL}/plot-area-ledger-report?${params.toString()}`;
      console.log("Fetching URL:", url);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch ledger data.");
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data.status === "1") {
        let transformedData = null;

        if (data.plots && data.plots.length > 0) {
          const plotData = data.plots[0];
          transformedData = {
            user: data.user || {},
            project: plotData.project || {},
            plot: plotData.plot || {},
            direct_entries: plotData.plot_entries || [],
            commission_entries: plotData.commissions || [],
            all_entries: [
              ...(plotData.plot_entries || []),
              ...(plotData.commissions || []),
            ],
          };
        } else if (data.data) {
          transformedData = data.data;
        }

        if (transformedData) {
          setLedgerData(transformedData);

          const totalEntries = transformedData.all_entries?.length || 0;
          setTotalPages(Math.ceil(totalEntries / 10) || 1);
          setCurrentPage(page);
        } else {
          setLedgerData(null);
          setError("No data found for this plot");
        }
      } else if (
        data.status === "1" &&
        data.message === "No entries found for this user on this plot"
      ) {
        setLedgerData({
          user: data.data?.user || {},
          project: data.data?.project || {},
          plot: data.data?.plot || {},
          direct_entries: [],
          commission_entries: [],
          all_entries: [],
        });
        setTotalPages(1);
        setCurrentPage(1);
        setError("No entries found for this user on this plot");
      } else {
        console.log("Unexpected response structure:", data);
        setLedgerData(null);
        setError(data.message || "No data found");
      }
    } catch (err) {
      console.error("Fetch ledger data error:", err);
      setLedgerData(null);
      setError("Failed to fetch ledger data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getFlatTableData = () => {
    if (!ledgerData) {
      return [];
    }

    const flatData = [];

    const project = ledgerData.project || {};
    const plot = ledgerData.plot || {};

    if (ledgerData.direct_entries && Array.isArray(ledgerData.direct_entries)) {
      ledgerData.direct_entries.forEach((entry) => {
        const newSqyd = parseFloat(entry.new_sqyd || 0);
        const oldSqyd = parseFloat(entry.old_sqyd || 0);
        const areaDistributed = (newSqyd - oldSqyd).toFixed(2);

        const dateTime = entry.status_date || "-";

        flatData.push({
          projectName: project.name || "-",
          unitNo: plot.plot_shop_villa_no || "-",
          name: entry.customer_name || "Customer",
          mobile: entry.customer_mobile || "-",
          oldSqyd: entry.old_sqyd || "0.00",
          newSqyd: areaDistributed,
          totalSqyd: entry.new_sqyd || "0.00",
          role:
            entry.level === "1"
              ? "Direct Customer"
              : `Level ${entry.level} Customer`,
          date: formatDateOnly(dateTime),
          approveDate: formatDateOnly(dateTime),
          type: "direct",
          level: entry.level,
          rate: entry.rate,
          grossPayout: entry.gross_payout,
          netPayout: entry.net_payout,
          created_at: entry.created_at || "",
          updated_at: entry.updated_at || "",
          lead_property_date: entry.status_date || "",
          lead_property_status_date: entry.status_date || "",
        });
      });
    }

    if (
      ledgerData.commission_entries &&
      Array.isArray(ledgerData.commission_entries)
    ) {
      ledgerData.commission_entries.forEach((commission) => {
        const newSqyd = parseFloat(commission.new_sqyd || 0);
        const oldSqyd = parseFloat(commission.old_sqyd || 0);
        const areaDistributed = (newSqyd - oldSqyd).toFixed(2);

        let role = `Level ${commission.level} Commission`;
        if (commission.user_id === ledgerData.user?.id) {
          role = `Level ${commission.level} Commission (Received)`;
        } else if (commission.parent_id === ledgerData.user?.id) {
          role = `Level ${commission.level} Commission (Given)`;
        }

        const dateTime = commission.status_date || "-";

        flatData.push({
          projectName: project.name || "-",
          unitNo: plot.plot_shop_villa_no || "-",
          name:
            commission.customer_name ||
            `Level ${commission.level} Associate`,
          mobile: commission.customer_mobile || "-",
          oldSqyd: commission.old_sqyd || "0.00",
          newSqyd: areaDistributed,
          totalSqyd: commission.new_sqyd || "0.00",
          role: role,
          date: formatDateOnly(dateTime),
          approveDate: formatDateOnly(dateTime),
          type: "commission",
          level: commission.level,
          commissionAmount:
            commission.commission_amount || commission.gross_payout,
          grossPayout: commission.gross_payout,
          netPayout: commission.net_payout,
          created_at: commission.created_at || "",
          updated_at: commission.updated_at || "",
          lead_property_date: commission.status_date || "",
          lead_property_status_date: commission.status_date || "",
        });
      });
    }

    flatData.sort((a, b) => {
      if (a.approveDate === "-") return 1;
      if (b.approveDate === "-") return -1;
      return new Date(a.approveDate) - new Date(b.approveDate);
    });

    console.log("Flat data for table:", flatData);
    return flatData;
  };

  const getCurrentPageData = () => {
    const flatData = getFlatTableData();
    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    return flatData.slice(startIndex, endIndex);
  };

  const getFilteredData = () => {
    const flatData = getFlatTableData();

    if (!searchQuery) {
      const startIndex = (currentPage - 1) * 10;
      const endIndex = startIndex + 10;
      return flatData.slice(startIndex, endIndex);
    }

    const filtered = flatData.filter(
      (entry) =>
        entry.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        entry.mobile?.includes(searchQuery) ||
        entry.role?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const newTotalPages = Math.ceil(filtered.length / 10);
    if (newTotalPages !== totalPages) {
      setTotalPages(newTotalPages || 1);
    }

    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    return filtered.slice(startIndex, endIndex);
  };

  useEffect(() => {
    if (ledgerData) {
      const flatData = getFlatTableData();
      setTotalPages(Math.ceil(flatData.length / 10) || 1);
    }
  }, [ledgerData]);

  const handleClearFilters = () => {
    setFormData({
      project_id: "",
      plot_id: "",
      start_date: "",
      end_date: "",
    });
    setLedgerData(null);
    setFilteredPlots([]);
    setSearchQuery("");
    setCurrentPage(1);
    setError(null);
  };

  const handleExportExcel = () => {
    const flatData = getFlatTableData();
    if (!flatData.length) return;

    const headers = [
      "SR. No.",
      "Date",
      "Project",
      "Unit",
      "Associate Name",
      "Associate Mobile",
      "Old SQYD",
      "New SQYD",
      "Total SQYD",
      "Level",
    ];

    const rows = flatData.map((entry, index) => [
      index + 1,
      entry.date,
      entry.projectName,
      entry.unitNo,
      entry.name,
      entry.mobile,
      entry.oldSqyd,
      entry.newSqyd,
      entry.totalSqyd,
      entry.level || "-",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    const date = new Date().toISOString().split("T")[0];
    a.download = `unit_sqyd_report_${date}.csv`;

    a.href = url;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  if (loading && projects.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="padding_15">
      <div className="userlist">
        <div className="card bg-white">
          <div className="card-header">
            <div className="d-flex align-items-md-center flex-wrap-mobile justify-content-between">
              <div className="titlepage">
                <h3 style={{ whiteSpace: "normal" }}>
                  Unit SQYD Added To All Associates In One Unit Lists
                </h3>
              </div>

              <div className="d-flex gap-2 align-items-center">
                {getFlatTableData().length > 0 && (
                  <Button
                    variant="success"
                    onClick={handleExportExcel}
                    title="Export to Excel"
                  >
                    <BsFiletypeXls /> Export
                  </Button>
                )}

                <button
                  className={`filter-toggle-btn btn btn-primary ${
                    isFilterActive ? "active" : ""
                  }`}
                  onClick={handleToggle}
                  title={isFilterActive ? "Hide Filters" : "Show Filters"}
                >
                  {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
                </button>
              </div>
            </div>
          </div>

          <div className="card-body">
            {/* ═══════════ FILTER SECTION ═══════════ */}
            {isFilterActive && (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                  flexWrap: "wrap",
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
                {/* Project */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "1 1 180px",
                    minWidth: 0,
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      minHeight: "22px",
                      marginBottom: "6px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#0f172a",
                      lineHeight: 1.2,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Project <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={formData.project_id}
                    onChange={handleProjectChange}
                    style={{
                      height: "44px",
                      padding: "0 14px",
                      fontSize: "14px",
                      border: "1.5px solid #e2e8f0",
                      borderRadius: "8px",
                      background: "#fff",
                      boxSizing: "border-box",
                    }}
                  >
                    <option value="">Select Project</option>
                    {projects.map((project) => (
                      <option key={project.id} value={project.id}>
                        {project.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Unit */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "1 1 180px",
                    minWidth: 0,
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      minHeight: "22px",
                      marginBottom: "6px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#0f172a",
                      lineHeight: 1.2,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Unit <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={formData.plot_id}
                    onChange={handlePlotChange}
                    disabled={!formData.project_id}
                    style={{
                      height: "44px",
                      padding: "0 14px",
                      fontSize: "14px",
                      border: "1.5px solid #e2e8f0",
                      borderRadius: "8px",
                      background: "#fff",
                      boxSizing: "border-box",
                    }}
                  >
                    <option value="">Select Unit</option>
                    {filteredPlots.map((plot) => (
                      <option key={plot.id} value={plot.id}>
                        {plot.plot_shop_villa_no} - {plot.colony_name}
                        {plot.total_area ? ` (${plot.total_area} sq.yd)` : ""}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Search */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "1.4 1 220px",
                    minWidth: 0,
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      minHeight: "22px",
                      marginBottom: "6px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#0f172a",
                      lineHeight: 1.2,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Search Associate
                  </label>
                  <input
                    type="text"
                    className="form-control py-2"
                    placeholder="Search by name, mobile or role..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{
                      height: "44px",
                      padding: "0 14px",
                      fontSize: "14px",
                      border: "1.5px solid #e2e8f0",
                      borderRadius: "8px",
                      background: "#fff",
                      boxSizing: "border-box",
                    }}
                  />
                </div>

                {/* Buttons */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    paddingTop: "28px",
                    flexShrink: 0,
                  }}
                >
                  <Button
                    variant="primary"
                    onClick={() => {
                      setCurrentPage(1);
                      fetchLedgerData();
                    }}
                    disabled={
                      !formData.project_id || !formData.plot_id || loading
                    }
                    style={{
                      height: "44px",
                      padding: "0 22px",
                      fontSize: "13.5px",
                      fontWeight: 600,
                      borderRadius: "8px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      background:
                        "linear-gradient(135deg, #1e1b4b 0%, #4c1d95 100%)",
                      border: "none",
                      boxShadow: "0 4px 12px rgba(76, 29, 149, 0.35)",
                      color: "#fff",
                    }}
                  >
                    {loading ? "Loading..." : "View Details"}
                  </Button>

                  <Button
                    variant="outline-light"
                    onClick={handleClearFilters}
                    style={{
                      height: "44px",
                      padding: "0 22px",
                      fontSize: "13.5px",
                      fontWeight: 600,
                      borderRadius: "8px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      background: "#ffffff",
                      border: "1.5px solid #e2e8f0",
                      color: "#475569",
                    }}
                  >
                    Clear
                  </Button>
                </div>
              </div>
            )}

            {/* ✅ Error — text only */}
            {error && (
              <div
                style={{
                  padding: "10px 14px",
                  background: "#fef2f2",
                  color: "#b91c1c",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 500,
                  marginBottom: "16px",
                  border: "1px solid #fecaca",
                }}
              >
                {error}
              </div>
            )}

            <div className="mb-4"></div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading ledger data...</p>
              </div>
            ) : (
              <>
                {/* Main User Card — only if ledgerData.user exists */}
                {ledgerData?.user && ledgerData.user.name && (
                  <Card className="mb-4 border-primary">
                    <Card.Header className="bg-primary text-white">
                      <h5 className="mb-0">
                        <BsPerson className="me-2" />
                        Main User Details
                      </h5>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col md={3}>
                          <strong>Name:</strong>
                          <p className="mb-0">
                            {ledgerData.user.name || "-"}
                          </p>
                        </Col>
                        <Col md={3}>
                          <strong>Mobile:</strong>
                          <p className="mb-0">
                            {ledgerData.user.mobile || "-"}
                          </p>
                        </Col>
                        <Col md={3}>
                          <strong>Total Area (SQYD):</strong>
                          <p className="mb-0">
                            {parseFloat(
                              ledgerData.user.buysqrt || 0
                            ).toFixed(2)}
                          </p>
                        </Col>
                        <Col md={3}>
                          <strong>Email:</strong>
                          <p className="mb-0">
                            {ledgerData.user.email || "-"}
                          </p>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}

                {/* ✅ Table — always visible */}
                <div className="table-responsive">
                  <Table striped bordered hover className="mb-0">
                    <thead className="table-dark">
                      <tr>
                        <th>SR. No.</th>
                        <th>Date</th>
                        <th>Project</th>
                        <th>Unit</th>
                        <th>Customer Name</th>
                        <th>Customer Mobile</th>
                        <th>Old SQYD</th>
                        <th>New SQYD</th>
                        <th>Total SQYD</th>
                        <th>Level</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getFilteredData().length > 0 ? (
                        getFilteredData().map((entry, index) => {
                          const actualIndex =
                            (currentPage - 1) * 10 + index + 1;

                          return (
                            <tr
                              key={`${entry.type}-${index}-${entry.mobile}`}
                            >
                              <td>{actualIndex}</td>
                              <td>{entry.date}</td>
                              <td>{entry.projectName}</td>
                              <td>{entry.unitNo?.toUpperCase()}</td>
                              <td>{entry.name}</td>
                              <td>{entry.mobile}</td>
                              <td>
                                {parseFloat(entry.oldSqyd).toFixed(2)}
                              </td>
                              <td>
                                {parseFloat(entry.newSqyd).toFixed(2)}
                              </td>
                              <td>
                                {parseFloat(entry.totalSqyd).toFixed(2)}
                              </td>
                              <td>{entry.level || "-"}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="10"
                            style={{
                              textAlign: "center",
                              padding: "30px 10px",
                              color: "#64748b",
                              fontWeight: "500",
                              background: "#f8fafc",
                            }}
                          >
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Pagination */}
                {getFilteredData().length > 0 && totalPages > 1 && (
                  <div className="d-flex justify-content-end mt-3">
                    <nav>
                      <ul className="pagination">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              handlePageChange(currentPage - 1)
                            }
                            disabled={currentPage === 1}
                          >
                            <HiOutlineChevronLeft />
                          </button>
                        </li>

                        {(() => {
                          const pages = [];
                          const maxVisiblePages = 5;

                          if (totalPages <= maxVisiblePages + 2) {
                            for (let i = 1; i <= totalPages; i++) {
                              pages.push(
                                <li
                                  key={i}
                                  className={`page-item ${
                                    i === currentPage ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(i)}
                                  >
                                    {i}
                                  </button>
                                </li>
                              );
                            }
                          } else {
                            pages.push(
                              <li
                                key={1}
                                className={`page-item ${
                                  1 === currentPage ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => handlePageChange(1)}
                                >
                                  1
                                </button>
                              </li>
                            );

                            if (currentPage > 3) {
                              pages.push(
                                <li
                                  key="ellipsis1"
                                  className="page-item disabled"
                                >
                                  <span className="page-link">...</span>
                                </li>
                              );
                            }

                            const start = Math.max(2, currentPage - 1);
                            const end = Math.min(
                              totalPages - 1,
                              currentPage + 1
                            );

                            for (let i = start; i <= end; i++) {
                              if (i > 1 && i < totalPages) {
                                pages.push(
                                  <li
                                    key={i}
                                    className={`page-item ${
                                      i === currentPage ? "active" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(i)}
                                    >
                                      {i}
                                    </button>
                                  </li>
                                );
                              }
                            }

                            if (currentPage < totalPages - 2) {
                              pages.push(
                                <li
                                  key="ellipsis2"
                                  className="page-item disabled"
                                >
                                  <span className="page-link">...</span>
                                </li>
                              );
                            }

                            if (totalPages > 1) {
                              pages.push(
                                <li
                                  key={totalPages}
                                  className={`page-item ${
                                    totalPages === currentPage
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() =>
                                      handlePageChange(totalPages)
                                    }
                                  >
                                    {totalPages}
                                  </button>
                                </li>
                              );
                            }
                          }

                          return pages;
                        })()}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              handlePageChange(currentPage + 1)
                            }
                            disabled={currentPage === totalPages}
                          >
                            <HiChevronRight />
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Unit_sqyd_added;